import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { interpreterSelector } from 'slices/interpreterSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/interpreterSlice';
import toast from 'react-hot-toast';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { stateSelector } from 'slices/stateSlice';
import { Select } from 'components/common/Select';
import { fetchLanguages } from 'slices/languageSlice';
import { fetchStates } from 'slices/stateSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PhoneInput from 'components/common/PhoneInput';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { updateVendorInterpreter } from 'slices/vendor/interpreterSlice';
import { addVendorInterpreter } from 'slices/vendor/interpreterSlice';
import { fetchVendorInterpreters } from 'slices/vendor/interpreterSlice';

const apiService = new Api();

const AddInterpreterForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1)
  const { state: states } = useSelector(stateSelector);
  const [allStates, setAllStates] = useState([]);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })
  const fileInputRef = React.useRef(null);
  const [localImage, setLocalImage] = React.useState('')
  const resetFileInput = () => {
    setLocalImage("")
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };


  const clearAll = () => {
    resetFileInput()
    setValue("first_name", '');
    setValue("last_name", '');
    setValue("email");
    setValue("phone", '');
    setValue('address', '')
    setValue("zip_code", "");
    setValue("city_id", "")
    setValue("state_id", [])
    setValue("language_ids", []);
    setStatus(1)

    clearErrors("city_id");
    clearErrors("state_id");
    clearErrors("language_ids");
    dispatch(setError({}))
    setLanguageState([])
  }

  useEffect(() => {
    setValue('first_name', item?.first_name || '');
    setValue('last_name', item?.last_name || '');
    setValue('email', item?.user?.email || '')
    setValue('phone', item?.phone || '');
    setValue('address', item?.address || '')
    setValue('zip_code', item?.zip_code || '');
    setValue('state_id', item?.state_id || '');
    setValue('city_id', item?.city_id || '');
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    return () => clearAll()

  }, [item]);


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchVendorInterpreters())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
    };
    
    if (item?.id) {
      dispatch(updateVendorInterpreter(data, item?.id, submitCallback));
    } else
      dispatch(addVendorInterpreter(data, submitCallback));

  }

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }))
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        value: item?.state?.id || "",
        label: item?.state?.name || "",
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])


  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    setAllStates(result?.data)
    return {
      options: result?.data?.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region Language dropdown
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })
  
  useEffect(() => {
    const langs = item?.languages;
    
    setLanguageState(
      langs?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  
    setValue(
      "language_ids",
      langs?.map(language => language.language_id)
    );
  }, [item?.languages]);

  console.log(item, "item")


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language?.id,
        label: language?.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  const options = {
    apiKey: "free",
    maxFileCount: 1
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row-primary">
          <h2>First Name *</h2>
          <Controller
            name="first_name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='first-name' placeholder='First name' required {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Last Name</h2>
          <Controller
            name="last_name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='last-name' placeholder='Last name' {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Email</h2>
          <div className="w-100">
            <Controller
              name="email"
              control={control}
              render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email'
                pattern={
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                }
                placeholder="Email Address"
                {...field}
              />}
            />
            {error?.errors?.email?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Phone Number</h2>
          <div className="w-100">
            <Controller
              name="phone"
              control={control}
              render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' {...field} />}
            />
            {error?.errors?.phone?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Address</h2>
          <Controller
            name="address"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Select State</h2>

          <Controller
            name="state_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterStates}
                  loadOptions={filteredStatesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setfilterStates(obj)
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                />
                {errors?.state_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.state_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>City</h2>
          <Controller
              name="city_id"
              control={control}
              render={({ field }) =>
                <input className="input-in type_inp" type="text" name='city_id' placeholder="City"
                  {...field}
                />
              }
            />
        </div>

        <div className="row-primary">
          <h2>Zip Code</h2>
          <div className='w-100'>
            <Controller
              name="zip_code"
              control={control}
              render={({ field }) =>
                <input className="input-in type_inp" type="text" name='zip_code' placeholder="Zip Code" {...field}/>
              }
            />
            {errors?.zip_code?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.zip_code?.message} />
              </div>
            }


            {error?.errors?.zip_code?.map((error) => (
              <div style={{ marginTop: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}

          </div>
        </div>

        <div className="row-primary">
          <h2>Select Languages *</h2>
          <Controller
            name="language_ids"
            required
            rules={{
              required: "Languages must be specified",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected)
                      field.onChange(selected?.map((opt) => opt?.value))
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.language_ids?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.language_ids?.message} />
                </div>}
              </div>
            }
          />
        </div>

        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status == 1 ? true : false}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        }


        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />
        </div>
      </form>
    </div>
  )
}

const AddInterpreter = ({ item, onClose, callback, show, statusPerm }) => {

  const closeButton = useRef(null)
  const refModal = useRef(null)
  const handleModalDismiss = () => {
    closeButton.current.click()
    onClose()
  };
  useEffect(() => {
    const modalElement = refModal.current;

    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);

  return (
    <div className={`modal fade`} ref={refModal} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Interpreter</h5>
            <button onClick={handleModalDismiss} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButton}></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddInterpreterForm item={item} handleClose={handleModalDismiss} callback={callback} show={show} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddInterpreter
